import {inject, observer} from 'mobx-react';
import React from 'react';
import {ThemeContext} from '../../apiContexts';
import Routers from '../../routes';
import ModalContainer from '../modal-container';

const AppContainer = ({theme, ...props}) => {
    return (
        <ThemeContext.Provider value={theme}>
            <ModalContainer>
                <Routers {...props} />
            </ModalContainer>
        </ThemeContext.Provider>
    );
};

const mapping = ({store}) => ({
    theme: store.theme,
});

export default inject(mapping)(observer(AppContainer));
